import { DestroyRef, Directive, inject, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroupDirective, NgControl } from '@angular/forms';
import { distinctUntilChanged, map, startWith, tap } from 'rxjs';

@Directive({ selector: '[appEnableControlWhen]' })
export class EnableControlWhenDirective implements OnInit {
  public inputConfig = input.required<{
    controlNameToWatch: string;
    enableWhenIs: (v: unknown) => boolean;
  }>({
    alias: 'appEnableControlWhen',
  });
  public emitEvent = input(true);

  private readonly _ngControl = inject(NgControl);
  private readonly _fgDirective = inject(FormGroupDirective);
  private readonly _destroyRef = inject(DestroyRef);

  ngOnInit() {
    const { controlNameToWatch, enableWhenIs } = this.inputConfig();
    const form = this._fgDirective.form;
    const currentControl = this._ngControl.control;

    const controlToWatch = form.get(controlNameToWatch);

    if (!controlToWatch || !currentControl) {
      console.error('error in EnableControlWhenDirective', {
        controlToWatch,
        currentControl,
      });
      return;
    }

    controlToWatch.valueChanges
      .pipe(
        startWith(controlToWatch.value),
        map((v) => enableWhenIs(v)),
        distinctUntilChanged(),
        tap((toEnable) => {
          if (toEnable) {
            currentControl.enable({ emitEvent: this.emitEvent() });
          } else {
            currentControl.disable({ emitEvent: this.emitEvent() });
          }
        }),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe();
  }
}
